module.exports = __webpack_public_path__ + "static/media/cu.f21e8506.svg";